<template>
  <div>
    <headerBox :current="7"></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div v-if="isPC" class="content_box guild_pc">
      <left-tabs
        ref="tabsChild"
        :bgColor="1"
        :menu="menuList"
        @change="getMenu"
      ></left-tabs>
      <div class="right_box">
        <!--协会简介-->
        <item1 v-if="current == 0"></item1>
        <!--协会章程-->
        <item2 v-if="current == 1"></item2>
        <!--领导机构-->
        <item3 v-if="current == 2"></item3>
        <!--协会荣誉-->
        <item4 v-if="current == 3"></item4>
        <!--联系我们-->
        <item5 v-show="current == 6" ref="hh"></item5>
        <!--自律委员会-->
        <item7 v-if="current == 4"></item7>
        <!--专家委员会-->
        <item8 v-if="current == 5"></item8>
        <!-- <item6 v-if="current==5"></item6> -->
      </div>
    </div>
    <div v-if="!isPC" class="guild_sj">
      <van-tabs
        v-model="current"
        :swipe-threshold="2"
        color="#2D85E2"
        @click="getSjMenu"
      >
        <van-tab v-for="(it, i) in menuList" :key="i" :title="it.title">
          <div style="margin-top: 10px">
            <item1 v-iif="current == 0"></item1>
            <item2 v-if="current == 1"></item2>
            <item3 v-if="current == 2"></item3>
            <item4 v-if="current == 3"></item4>
            <item5 v-show="current == 6" ref="hh"></item5>
            <item7 v-if="current == 4"></item7>
            <item8 v-if="current == 5"></item8>
            <!-- <item6 v-if="current==5"></item6> -->
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import leftTabs from "@/components/left_tabs.vue";
import item1 from "./components/item1.vue";
import item2 from "./components/item2.vue";
import item3 from "./components/item3.vue";
import item4 from "./components/item4.vue";
import item5 from "./components/item5.vue";
import item6 from "./components/item6.vue";
import item7 from "./components/item7.vue";
import item8 from "./components/item8.vue";
import { getArticle } from "@/api/home/index";
export default {
  name: "home",
  components: {
    bannerBox,
    headerBox,
    footerBox,
    leftTabs,
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item7,
    item8,
  },
  data() {
    return {
      locationList: [],
      current: 0,
      menuList: [
        {
          title: "协会简介",
        },
        {
          title: "协会章程",
        },
        {
          title: "领导机构",
        },
        {
          title: "协会荣誉",
        },

        {
          title: "自律委员会",
        },
        {
          title: "专家委员会",
        },
        {
          title: "联系我们",
        },
        // {
        // 	title: '意见反馈',
        // },
      ],
      isPC: !window.matchMedia("(max-width: 800px)").matches,
    };
  },
  mounted() {
    let index = this.menuList.findIndex(
      (v) => v.title == decodeURIComponent(this.$route.query.name),
    );
    this.setLocation(index);
  },
  methods: {
    getMenu() {
      this.setLocation();
    },
    setLocation(index) {
      let current =
        index || index == 0 ? index : this.$refs["tabsChild"].current;
      this.current = current;
      let locationList = ["关于协会", this.menuList[current].title];
      this.locationList = locationList;
      this.$refs["tabsChild"].current = current;
      this.$refs["bannerChild"].locationList = locationList;

      // if(this.$route.query.subName){
      // 	let subName = decodeURIComponent(this.$route.query.subName)
      // 	this.$refs["hh"].subName = subName;
      // }
    },
    getSjMenu(e) {
      this.setLocation(e);
    },
  },
};
</script>

<style lang="scss" scoped>
// 大屏幕
@media only screen and (min-width: 800px) {
  .content_box {
    margin: 80px 100px;
    display: flex;
    min-width: 1100px;
    .right_box {
      width: 75%;
    }
  }

  .guild_pc {
    display: flex;
  }

  .guild_sj {
    display: none;
  }
}

/* 手机 */
@media only screen and (max-width: 800px) {
  .guild_pc {
    display: none !important;
  }

  .guild_sj {
    padding: 10px;
    padding-bottom: 100px !important;
    display: flex !important;

    /deep/.van-tab {
      padding: 0 15px;
      font-size: 17px !important;
      width: auto !important;
    }

    /deep/.van-tabs__nav--line {
      padding-bottom: 10px;
    }
  }
}
</style>
